import _ from 'underscore';
import { getEntityFromScope } from '@bingads-webui/edm-campaign';
import { setCampaignTypes } from '@bingads-webui-campaign-react/with-campaign-type';

const initCampaignTypes = ({ currentAccount }, { campaignTypes }) => {
  if (!_.isEmpty(currentAccount) && !_.isEmpty(campaignTypes)) {
    currentAccount['Default.CampaignTypes'].$makeCall({
      hardResetData: {
        value: campaignTypes.split(','),
      },
    });
  }
};

const initSingleCampaign = ({ currentCampaign }, campaign) => {
  if (!_.isEmpty(currentCampaign) && !_.isEmpty(campaign)) {
    currentCampaign.get({}, campaign);
  }
};

const initTopTwoCampaigns = ({ currentAccount }, campaigns) => {
  if (!_.isEmpty(currentAccount) && !_.isEmpty(campaigns)) {
    currentAccount.Campaigns.get({ top: 2, skip: 0, select: ['Id', 'CampaignType'] }, { value: campaigns });
  }
};

export const initOdataCache = (serverContext) => {
  const {
    CurrentCustomer: { Id: cid },
    CurrentAccount: { Id: aid },
    ODataPrefetchResult,
  } = serverContext;
  let campaigns = [];
  if (_.get(serverContext, ['ODataPrefetchResult', 'topTwoCampaigns'], false)) {
    campaigns = _.isEmpty(serverContext.ODataPrefetchResult.topTwoCampaigns) ? [] : JSON.parse(serverContext.ODataPrefetchResult.topTwoCampaigns);
    setCampaignTypes(campaigns);
  }
  let campaignId;
  if (_.size(campaigns) === 1) {
    campaignId = _.get(_.first(campaigns), 'Id');
  }

  const entities = getEntityFromScope({ values: { cid, aid, campaignId } });

  initCampaignTypes(entities, ODataPrefetchResult);
  initTopTwoCampaigns(entities, campaigns);

  const campaignString = _.get(serverContext, ['ODataPrefetchResult', 'campaign'], '');
  const campaign = _.isEmpty(campaignString) ? null : JSON.parse(campaignString);
  if (!_.isEmpty(campaign) && _.get(campaign, 'Id')) {
    initSingleCampaign(getEntityFromScope({ values: { cid, aid, campaignId: campaign.Id } }), campaign);
  }

  if (campaignId && campaignId !== _.get(campaign, 'Id')) {
    initSingleCampaign(entities, _.first(campaigns));
  }
};
